<mat-card class="holding-card mat-elevation-z2" (click)="reportHoldingClickedEvent()"
[ngClass]="{ 'example-strip': holding.id === EXAMPLE_ASSET_ID,
            'holding-realized': holding?.status === HoldingStatus.Realized,
            'has-active-capital-call':(hasActiveCapitalCall$ | async) && !isOpportunity,
            'asset-card': isAsset,
            'fund-card': isFund,
            'example-card': holding.id === EXAMPLE_ASSET_ID }">

      <div class="wrap" *ngIf="holding?.status === HoldingStatus.Realized">
        <span class="ribbon">REALIZED</span>
      </div>


    <span *ngIf="holding.id !== EXAMPLE_ASSET_ID" [ngClass]="{ 'asset-label': isAsset, 'fund-label': isFund }">{{ holdingType }}</span>
    <div class="image-box" [style.background-image]="'url(' + backgroundImageUrl + ')'">
      <terra-private-holding-notification [holding]="holding"></terra-private-holding-notification>
    </div>

    <mat-card-content class="header-content"
    [ngClass]="{'asset-header-content-border': isAsset && (!!position || (hasActiveCapitalCall$ | async)),
    'fund-header-content-border': isFund && (!!position || (hasActiveCapitalCall$ | async))}">
    <div class="position-and-type">
      <div class="position" *ngIf="!shouldInterpolateLocation">
        {{holding.location}}
      </div>
      <div class="position" *ngIf="shouldInterpolateLocation">
        {{holding.location | locationToString:'short'}}
      </div>
      <ng-container *ngIf="!!holding.holdingType">
        <div>|</div>
        <div class="type">
          {{holding.holdingType | enumString:HoldingType}}
        </div>
      </ng-container>
    </div>
    <h3 class="holding-name">{{ holding?.name }}</h3>
    <h4 class="company-name">{{ holding?.agentCompanyName || holding?.gpDetails?.agentCompanyName}}</h4>
    </mat-card-content>

    <mat-card-content class="details-content" *ngIf="position && !isOpportunity">
      <div class="holding-details">
        <div class="holding-details-item" *ngIf="position.totalInvested > 0">
          <span class="label">{{totalInvestedLabel}}</span>
          <span class="label-val">
            {{position.contributionsCurrency?.symbol || position.contributionsCurrency }}{{position.totalInvested | terraNumber}}
          </span>
        </div>
        <div class="holding-details-item" *ngIf="!!position.cashOnCashRatePercentage">
          <span class="label">Cash on Cash</span>
          <span class="label-val">
            {{position.cashOnCashRatePercentage | terraNumber}}%
          </span>
        </div>
        <div class="holding-details-item" *ngIf="position.totalCommited > 0">
          <span class="label">Total Committed</span>
          <span class="label-val">
            {{position.contributionsCurrency?.symbol || position.contributionsCurrency }}{{position.totalCommited | terraNumber}}
          </span>
        </div>
        <div class="holding-details-item">
          <span class="label">Total Distributed</span>
          <span class="label-val">
            {{position.distributionsCurrency?.symbol || position.distributionsCurrency }}{{position.totalDistributed | terraNumber}}
          </span>
        </div>
        <div class="holding-details-item" *ngIf="!!position.totalShares">
          <span class="label">Shares</span>
          <span class="label-val">
            {{position.totalShares | terraNumber}}
          </span>
        </div>
        <div class="holding-details-item" *ngIf="!!position.netAssetValue">
          <span class="label">Net Asset Value</span>
          <span class="label-val">
            {{position.contributionsCurrency?.symbol || position.contributionsCurrency }}{{position.netAssetValue | terraNumber}}
          </span>
        </div>
        <div class="holding-details-item" *ngIf="!!position.ownershipPercentage">
          <span class="label">Ownership</span>
          <span class="label-val">
            {{position.ownershipPercentage | terraNumber}}%
          </span>
        </div>
      </div>
    </mat-card-content>

    <mat-card-content class="details-content" *ngIf="isOpportunity">
      <div class="holding-details">
        <div class="holding-details-item" *ngIf="!!holding.investmentType">
          <span class="label">Investment Type</span>
          <span class="label-val">
            {{holding.investmentType | enumString: InvestmentType}}
          </span>
        </div>
        <div class="holding-details-item" *ngIf="!!holding.targetInvestmentIrr">
          <span class="label">Target Investor IRR</span>
          <span class="label-val">
            {{holding.targetInvestmentIrr | terraNumber}}%
          </span>
        </div>
        <div class="holding-details-item" *ngIf="!!holding.minimumInvestmentAmount">
          <span class="label">Minimum Investment</span>
          <span class="label-val">{{holding.fundraisingTargetCurrency?.symbol || holding.fundraisingCurrencySymbol }}{{holding.minimumInvestmentAmount | terraNumber}}</span>
        </div>
      </div>
    </mat-card-content>

    <mat-card-content class="view-content" *ngIf="isOpportunity">
      <div class="view-opportunity">
        View Opportunity
      </div>
    </mat-card-content>


    <mat-card-content *ngIf="(hasActiveCapitalCall$ | async) && !isOpportunity">
      <div class="capital-call-message" >
        <strong>Pending Capital Call</strong>
      </div>
    </mat-card-content>
  </mat-card>
